import { render, staticRenderFns } from "./ReviewPaymentOrder.vue?vue&type=template&id=79ad5d8c&"
import script from "./ReviewPaymentOrder.vue?vue&type=script&lang=js&"
export * from "./ReviewPaymentOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports